var map = {
	"./ave2/logo.png": "a992",
	"./eleganza4/logo.png": "d9cd",
	"./essenza200/logo.png": "5c6d",
	"./essenza300/logo.png": "7bfc",
	"./essenza300lt/logo.png": "838b",
	"./gracie/logo.png": "d49f",
	"./multicare/logo.png": "cadb",
	"./sprint/logo.png": "9636"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd71";